import { ADMIN_ROLES } from "../../common/constants";
import { useRoles } from "../useRoles";

export function useCanAddAccounts() {
    return useRoles(ADMIN_ROLES);
}
